"use client"; // Error components must be Client Components

import { useEffect } from "react";

import Image from "next/image";

import { useUser } from "@clerk/nextjs";

import { Button } from "@/components/atoms/button/button";
import Footer from "@/components/atoms/footer";
import Sidebar from "@/components/atoms/sidebar";
import Header from "@/components/organisms/navbar/header";

interface AppErrorPageProps {
  error: Error;
  digest?: string;
}

export default function AppErrorPage({
  error,
  // reset,
}: AppErrorPageProps) {
  const { user } = useUser();

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <>
      <Header type={user?.publicMetadata?.role} />
      <Sidebar type={user?.publicMetadata?.role} />
      <main className="flex h-dvh w-dvw flex-col">
        <div className="flex h-full flex-col items-center justify-center gap-4 bg-dr-white-100">
          <div className="relative flex h-[253px] w-[252px] sm:h-[382px] sm:w-[380px]">
            <Image
              className="px-4"
              src="/imgs/server-error-illustration.svg"
              fill
              unoptimized
              alt="Um erro inesperado aconteceu"
              aria-hidden
            />
          </div>
          <h3 className="text-center text-base font-medium text-raven sm:text-2xl sm:font-normal 4xl:text-3xl 4xl:font-medium 4xl:leading-10">
            Ops, tivemos um problema
          </h3>
          <p className="text-center text-sm text-raven sm:text-xl 4xl:text-2xl 4xl:leading-7">
            Utilize o botão abaixo para tentar novamente.
          </p>
          <Button
            className="bg-aubergine-perl-500 text-sm sm:text-base"
            variant="primary"
            // Attempt to recover by trying to re-render the segment
            onClick={() => window.location.reload()}
          >
            Atualizar a página
          </Button>
        </div>
        <Footer />
      </main>
    </>
  );
}

AppErrorPage.getInitialProps = ({
  req,
  res,
  err,
}: {
  req: any;
  res: any;
  err: any;
}) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  // Only require Rollbar and report error if we're on the server
  if (typeof window !== "undefined") {
    console.log("Reporting error to Rollbar...");
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const Rollbar = require("rollbar");
    const rollbar = new Rollbar(process.env.ROLLBAR_SERVER_TOKEN);
    rollbar.error(err, req, (rollbarError: any) => {
      if (rollbarError) {
        console.error("Rollbar error reporting failed:");
        console.error(rollbarError);
        return;
      }
      console.log("Reported error to Rollbar");
    });
  }
  return { statusCode };
};
